import { render } from "./ActiviteItem.vue?vue&type=template&id=65f2a92e"
import script from "./ActiviteItem.vue?vue&type=script&lang=js"
export * from "./ActiviteItem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__